// extracted by mini-css-extract-plugin
export default {"custom-select":"CustomSelect_custom-select__Q43Ub","corporate-filter__selector":"CustomSelect_corporate-filter__selector__5ertL"};